<video
  [ngStyle]="{ display: showThumb ? 'block' : 'none' }"
  [ngClass]="{'full': isFullScreen}"
  autoplay
  width="100%"
  height="100%"
  #thumb
  id="thumb"
  type="video/mp4"
></video>
<div id="playback-loop" #playbackLoop></div>
<div id="play-progress"></div>
<div id="duration-bar">
  <input 
    #currentSliderInput 
    type="range" 
    [min]="-loopDuration" 
    max="0" 
    [step]=".01"
  />
</div>
